import { __decorate as t, __classPrivateFieldGet as s, __classPrivateFieldSet as e } from "tslib";
import { LitElement as i, html as r } from "lit";
import { property as l } from "lit/decorators.js";
import o from "@inera/ids-design/components/grid/container/container-lit.js";
var d, n, a;
class h extends i {
  constructor() {
    super(...arguments), d.set(this, !1), n.set(this, ""), a.set(this, !1);
  }
  get fluid() {
    return s(this, d, "f");
  }
  set fluid(t) {
    e(this, d, t, "f");
  }
  get width() {
    return s(this, n, "f");
  }
  set width(t) {
    e(this, n, t, "f");
  }
  get gutterless() {
    return s(this, a, "f");
  }
  set gutterless(t) {
    e(this, a, t, "f");
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.classList.add("ids-container"), this.width && !this.fluid && (this.style.maxWidth = `${this.width}px`), this.fluid && this.classList.add("ids-container--fluid"), this.gutterless && this.classList.add("ids-container--gutterless");
  }
  render() {
    return r`<slot></slot>`;
  }
}
d = new WeakMap(), n = new WeakMap(), a = new WeakMap(), h.styles = [o], t([l({
  type: Boolean,
  reflect: !0
})], h.prototype, "fluid", null), t([l({
  type: String
})], h.prototype, "width", null), t([l({
  type: Boolean,
  reflect: !0
})], h.prototype, "gutterless", null);
export { h as IDSContainer };